<ul class="list-unstyled topbar-nav mb-0">
@if (companyId === 2 || companyId === 155) {
  <li class="notification-list d-none d-xl-inline-block header-action-compact-hide header-action-wide-hide">
    <a class="nav-link arrow-none  show" title="Ring Central" (click)="showNiceInContact('ring-central')" tabindex="0" (keydown.enter)="showNiceInContact('ring-central')"
      role="button">
      <img src="assets/images/ringcentral-logo.png" class="in-contact-headphones-button" alt="Ring Central"/>
      <!--
      @if(alertsAndNotifications.totalAlertCount) {
        <span class="badge bg-danger noti-icon-badge">{{alertsAndNotifications.totalAlertCount > 99 ? '+99' : alertsAndNotifications.totalAlertCount}}</span>
      }
      -->
    </a>
  </li>
}
@if (companyId === 2 || companyId === 155) {
  <li class="notification-list d-none d-xl-inline-block header-action-compact-hide header-action-wide-hide">
    <a class="nav-link arrow-none  show" title="Nice In Contact" (click)="showNiceInContact('nice-in-contact')" tabindex="0" (keydown.enter)="showNiceInContact('nice-in-contact')"
      role="button">
      <img src="assets/images/incontact-logo.png" class="in-contact-headphones-button" alt="Nice In Contact"/>
    </a>
  </li>
}

@if (!isSuperAdmin && !isCompanyPHM) {
  <li class="header-action-compact-hide header-action-wide-hide">
    <calls-on-leads-on></calls-on-leads-on>
  </li>
}

<li class="notification-list d-none d-sm-inline-block header-action-compact-hide">
  <a class="nav-link arrow-none  show" title="Support" (click)="onSupportLinkClicked()" tabindex="0" (keydown.enter)="onSupportLinkClicked()"
    role="button">
    <i-lucide name="headphones" [size]="17" [strokeWidth]="1.75" class="topbar-lucide"></i-lucide>
  </a>
</li>
@if (applicationMode === 1) {
  <li class="dropdown header-action-search">
    <a class="nav-link dropdown-toggle arrow-none " id="search-bar-animation"
      data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false"
      data-bs-display="static" [ngbTooltip]="'Search'" placement="bottom" container="body"
      (click)="onSearchIconClicked()">
      <i-lucide name="search" [size]="17" [strokeWidth]="1.75" class="topbar-lucide"></i-lucide>
    </a>
    <div class="dropdown-menu dropdown-search-menu dropdown-menu-end p-0">
      <div class="app-search-popover">
        <div class="app-search-popover__header">
          <span>Search</span>
          <small>Find records across Lodasoft</small>
        </div>
        <form name="searchForm" id="searchForm" class="app-search-popover__form" (ngSubmit)="search()">
          <div class="app-search-popover__field">
            <i-lucide name="search" [size]="17" [strokeWidth]="1.75"></i-lucide>
            <input
              type="search"
              [pattern]="searchMode === 'SSN' ? ssnPattern : null"
              [mask]="searchMode === 'SSN' ? '000-00-0000' : null"
              [showMaskTyped]="true"
              [dropSpecialCharacters]="false"
              name="searchInput"
              id="searchInput"
              [(ngModel)]="searchText"
              class="form-control app-search-popover__input"
              placeholder="Enter a name, phone, email, or address"
              autocomplete="off">
          </div>
          <div class="app-search-popover__controls">
            <label class="visually-hidden" for="search-mode">Search by</label>
            <select
              id="search-mode"
              name="searchMode"
              class="form-select app-search-popover__select"
              [(ngModel)]="searchMode">
              <option value="Contains">Global</option>
              <option value="Name">Name</option>
              <option value="Address">Address</option>
              <option value="Phone">Phone</option>
              <option value="Email">Email</option>
              <option value="SSN">SSN</option>
            </select>
            <button type="submit" class="btn app-search-popover__button">
              <i-lucide name="search" [size]="16" [strokeWidth]="2"></i-lucide>
              <span>Search</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </li>
  }

  <li class="notification-list d-none d-sm-inline-block header-action-compact-hide">
    <a class="nav-link arrow-none  show" (click)="showDialpad()" tabindex="0" (keydown.enter)="showDialpad()" role="button" title="Dialpad">
      <i-lucide name="phone" [size]="17" [strokeWidth]="1.75" class="topbar-lucide"></i-lucide>
    </a>
  </li>

  <li class="notification-list d-none d-sm-inline-block header-action-compact-hide">
    <a class="nav-link arrow-none  show" (click)="showNotifications()" tabindex="0" (keydown.enter)="showNotifications()" role="button" title="Alerts / Notifications">
      <i-lucide name="bell" [size]="17" [strokeWidth]="1.75" class="topbar-lucide badge-notify"></i-lucide>
      @if (alertsAndNotifications.totalAlertCount) {
        <span class="badge bg-danger noti-icon-badge"
          >{{alertsAndNotifications.totalAlertCount > 99 ? '+99' :
        alertsAndNotifications.totalAlertCount}}</span>
      }
    </a>
  </li>

  <li class="notification-list d-none d-sm-inline-block header-action-compact-hide">
    <a class="nav-link arrow-none  show" (click)="showMentions()" tabindex="0" (keydown.enter)="showMentions()" role="button" title="Mentions">
      <i-lucide name="at-sign" [size]="17" [strokeWidth]="1.75" class="topbar-lucide badge-notify"></i-lucide>
      @if (unreadMentionCount > 0) {
        <span class="badge bg-danger noti-icon-badge">
          {{unreadMentionCount >= 200 ? '+200' : unreadMentionCount}}
        </span>
      }
    </a>
  </li>

  <li class="notification-list">
    <a class="nav-link arrow-none  show" (click)="showConversations()" tabindex="0" (keydown.enter)="showConversations()" role="button" title="Conversations">
      <i-lucide name="message-circle" [size]="17" [strokeWidth]="1.75" class="topbar-lucide badge-notify"></i-lucide>
      @if (!!unreadConversations) {
        <span class="badge bg-danger noti-icon-badge chatList-count"></span>
      }
    </a>
  </li>

  <li class="dropdown header-action-overflow">
    <a class="nav-link dropdown-toggle arrow-none show" data-bs-toggle="dropdown" href="#"
      role="button" aria-haspopup="false" aria-expanded="false" title="More actions"
      [class.is-indicated]="hasOverflowIndicator">
      <i-lucide name="more-horizontal" [size]="22" [strokeWidth]="1.75" class="topbar-lucide"></i-lucide>
    </a>
    <div class="dropdown-menu dropdown-menu-end header-action-overflow-menu border-radius-10">
      @if (companyId === 2 || companyId === 155) {
        <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="showNiceInContact('ring-central')" tabindex="0" (keydown.enter)="showNiceInContact('ring-central')">
          <img src="assets/images/ringcentral-logo.png" class="overflow-brand-img me-2" alt="Ring Central" /> Ring Central
        </a>
        <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="showNiceInContact('nice-in-contact')" tabindex="0" (keydown.enter)="showNiceInContact('nice-in-contact')">
          <img src="assets/images/incontact-logo.png" class="overflow-brand-img me-2" alt="Nice In Contact" /> Nice In Contact
        </a>
        <div class="dropdown-divider mt-1"></div>
      }

      @if (!isSuperAdmin && !isCompanyPHM) {
        <div class="dropdown-item-text compact-calls-on-leads">
          <calls-on-leads-on></calls-on-leads-on>
        </div>
        <div class="dropdown-divider mt-1"></div>
      }

      @if (applicationMode === 1) {
        <a class="dropdown-item classic-dropdown-item-padding font-14 header-action-overflow-compact-only"
          (click)="onCompactSearchClicked()" tabindex="0" (keydown.enter)="onCompactSearchClicked()">
          <i class="pi pi-search me-1"></i> Search
        </a>
      }
      <a class="dropdown-item classic-dropdown-item-padding font-14 header-action-overflow-compact-only"
        (click)="onSupportLinkClicked()" tabindex="0" (keydown.enter)="onSupportLinkClicked()">
        <i class="pi pi-headphones me-1"></i> Support
      </a>
      <a class="dropdown-item classic-dropdown-item-padding font-14 header-action-overflow-compact-only"
        (click)="showDialpad()" tabindex="0" (keydown.enter)="showDialpad()">
        <i class="pi pi-phone me-1"></i> Dialpad
      </a>
      <a class="dropdown-item classic-dropdown-item-padding font-14 header-action-overflow-compact-only"
        (click)="showNotifications()" tabindex="0" (keydown.enter)="showNotifications()">
        <i class="pi pi-bell me-1"></i>
        Alerts/Notifications
        @if (alertsAndNotifications.totalAlertCount) {
          <span class="badge bg-danger ms-2">
            {{alertsAndNotifications.totalAlertCount > 99 ? '+99' : alertsAndNotifications.totalAlertCount}}
          </span>
        }
      </a>
      <a class="dropdown-item classic-dropdown-item-padding font-14 header-action-overflow-compact-only"
        (click)="showMentions()" tabindex="0" (keydown.enter)="showMentions()">
        <i class="pi pi-at me-1"></i>
        Mentions
        @if (unreadMentionCount > 0) {
          <span class="badge bg-danger ms-2">{{unreadMentionCount >= 200 ? '+200' : unreadMentionCount}}</span>
        }
      </a>
    </div>
  </li>

  <li class="dropdown" [class.is-disconnected]="isDisconnected">
    <a class="nav-link dropdown-toggle arrow-none nav-user" data-bs-toggle="dropdown" href="#"
      role="button" aria-haspopup="false" aria-expanded="false">
      <app-user-avatar [user]="user"></app-user-avatar>
      <i class="fa-solid fa-chevron-down nav-user-caret" aria-hidden="true"></i>
    </a>
    <div class="dropdown-menu dropdown-menu-end nextgen-profile-menu dropdown-profile border-radius-10"
      [class.dropdown-profile--appearance]="appearanceAvailable && applicationMode === 1">
      <a class="dropdown-item">
        <img [src]="user?.userImage || 'assets/images/user-5.jpg'" alt="profile-user"
          class="rounded-circle thumb-sm">
          <span class="nav-user-name  fw-semibold px-1">{{user?.firstName || 'John Doe' }} {{user?.lastName}}</span>
        </a>

        <div class="dropdown-divider mb-1 mt-1"></div>

        @if (companyId === 2 || isSuperAdmin) {
          <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="onGotoNextGenClicked()" tabindex="0" (keydown.enter)="onGotoNextGenClicked()">
            <i class="pi pi-bolt"></i>
            {{applicationMode === 1 ? "Experience NextGen" : "Switch to Classic Mode" }}
          </a>
          <div class="dropdown-divider mb-1 mt-1"></div>
        }

        @if (currentUserIsPrimaryRoleUser && wizardUrls.length === 1) {
          <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="copyLink(wizardUrls[0])" tabindex="0" (keydown.enter)="copyLink(wizardUrls[0])">
            <i class="pi pi-chart-line align-self-center me-1"></i>
            Online App Link
          </a>
          <div class="dropdown-divider mb-1 mt-1"></div>
        }

        <a class="dropdown-item classic-dropdown-item-padding font-14"
          [routerLink]="applicationMode === 1 ? ['/admin/profile'] : ['/loda-nextgen/profile']">
          <i class="pi pi-user align-self-center me-1"></i> Profile
      </a>
      <a class="dropdown-item classic-dropdown-item-padding font-14"
        [routerLink]="applicationMode === 1 ? ['/admin/settings'] : ['/loda-nextgen/settings']">
        <i class="pi pi-cog align-self-center me-1"></i> Settings
    </a>
    <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="showTestAudioSettings()" tabindex="0" (keydown.enter)="showTestAudioSettings()">
      <i class="pi pi-microphone align-self-center me-1"></i>  Test Audio Settings
    </a>
    <a class="dropdown-item classic-dropdown-item-padding font-14"
      [routerLink]="applicationMode === 1 ? ['/admin/change-password'] : ['/loda-nextgen/change-password']">
      <i class="pi pi-lock align-self-center me-1"></i>
        Change Password
    </a>

    <!-- Appearance choices theme Classic Admin only; NextGen pages always render light. -->
    @if (appearanceAvailable && applicationMode === 1) {
      <div class="dropdown-divider mb-1 mt-1"></div>
      <div class="profile-appearance">
        <div class="profile-appearance__heading">
          <span id="header-appearance-label">Appearance</span>
        </div>
        <appearance-toggle labelledBy="header-appearance-label" [preference]="appearance"
          (preferenceChange)="onAppearanceChosen($event)"></appearance-toggle>
      </div>
    }

    <div class="dropdown-divider mb-1 mt-1"></div>

      @if (companies && companies.length > 1) {
        <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="onSwitchCompanyClicked()" tabindex="0" (keydown.enter)="onSwitchCompanyClicked()">
          <i class="pi pi-sync align-self-center me-1"></i>
          Switch Companies
        </a>
        <div class="dropdown-divider mt-1"></div>
      }

      @if (isAdmin && hasImpersonateAdminUserRight) {
        <a class="dropdown-item classic-dropdown-item-padding font-14"
          (click)="showImpersonateUserDialog()" tabindex="0" (keydown.enter)="showImpersonateUserDialog()">
          <i class="pi pi-user align-self-center me-1"></i> Impersonate User
      </a>
      <div class="dropdown-divider mt-1"></div>
    }

    <ng-container>
      <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="onClearCacheClicked()" tabindex="0" (keydown.enter)="onClearCacheClicked()">
        <i class="pi pi-trash align-self-center me-1"></i>
        Clear Cache
      </a>
      <div class="dropdown-divider mt-1"></div>
    </ng-container>

    <a class="dropdown-item classic-dropdown-item-padding font-14" (click)="onLogoutClicked()" tabindex="0" (keydown.enter)="onLogoutClicked()">
      <i class="pi pi-power-off align-self-center me-1"></i>
      Logout
    </a>
    <div class="dropdown-divider mt-1"></div>
    <a class="dropdown-item dropdown-last-login font-12 mb-1">Last Login: {{user.lastTimeLogin}} </a>
    @if (version) {
      <a class="dropdown-item dropdown-last-login font-12">Version: {{version}}</a>
    }
    @if (version && version !== 'local') {
      <a class="dropdown-item dropdown-last-login font-10" style="color: #adb5bd;">Build: {{version}}</a>
    }
  </div>
</li>

<!--end menu item-->
</ul>
